import React from 'react';
import { Button } from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * 그룹 사용자 관리 액션 셀 컴포넌트
 * 
 * 교육생 관리와 FT/OPER 관리 버튼을 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {number} params.row.groupId - 그룹ID
 */
const GroupActionsCell = ({ row }) => {
  const navigate = useNavigate();

  const handleUserListClick = (e) => {
    e.stopPropagation(); // 행 클릭 이벤트 방지
    navigate(`/groups/${row.groupId}/users`);
  };

  const handleManagerListClick = (e) => {
    e.stopPropagation(); // 행 클릭 이벤트 방지
    navigate(`/groups/${row.groupId}/managers`);
  };

  return (
    <div style={{ display: 'inline-flex', gap: 4, justifyContent: 'center', alignItems: 'center' }}>
      <Button
        variant="outlined"
        size="small"
        startIcon={<PeopleIcon />}
        onClick={handleUserListClick}
      >
        교육생 관리
      </Button>
      <Button
        variant="outlined"
        size="small"
        startIcon={<PeopleIcon />}
        onClick={handleManagerListClick}
      >
        FT / OPER 관리
      </Button>
    </div>
  );
};

export default GroupActionsCell;
